export function getDropdownOptions(data) {
  return (data && Object.entries(data)?.map(([value, label]) => ({ value: Number(value), label }))) || [];
}
